import type { RouterLocale } from './constants';
import { locales } from './constants';

export const isLocale = (locale?: string): locale is RouterLocale => {
	return !!locales.find((e) => e === locale);
};
